import { getActionHandler, getInitialState } from "../helpers/crudReducers";

const initialState = getInitialState("PROPOSALS");
const CRUD_ACTION_HANDLERS = getActionHandler("PROPOSALS");

export default function proposals(state = initialState, action) {
  const handler = CRUD_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
